import { render, staticRenderFns } from "./oldManFileFirst.vue?vue&type=template&id=c2d50cae&scoped=true&"
import script from "./oldManFileFirst.vue?vue&type=script&lang=js&"
export * from "./oldManFileFirst.vue?vue&type=script&lang=js&"
import style0 from "./oldManFileFirst.vue?vue&type=style&index=0&id=c2d50cae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d50cae",
  null
  
)

export default component.exports